import { dataHooks } from '@wix/data-hooks'

export const errorNotificationDataHooks = dataHooks<{
  notification: {}
  outlet: {}
}>('error-notification')
